import React from 'react';
import { InformationPanel, TextParagraph } from '../../common/informationPanel/InformationPanel';

export const DecommissionASiteInProgressScreen = () => {
  const waitingForResponsePanelText: TextParagraph[] = [
    {
      text: 'Decommissioning...',
      lineBreak: false,
    },
  ];

  return (
    <>
      {/* TODO add loading spinner here */}
      <InformationPanel
        title={null}
        textArray={waitingForResponsePanelText}
        background={false}
        textAlign={'center'}
        dataTestId={'info-panel-loading'}
      />
    </>
  );
};
